<template>
    <el-card class="im-notify" v-if="list.length>0">
        <div class="title-group font14px text-bold">消息通知（{{list.length<=10?list.length:'10+'}}）</div>
        <div class="message-list">
            <ul>
                <li v-for="item in list" :key="item.msg_id" class="pointer list-item" @click="openMessage(item)">
                    <p class="ellipsis">
                        <i class="icon iconfont icon-jt-gonggao ver-middle mr10"></i>
                        <span v-if="item.msg_type_id==3">通知提醒：</span>
                        <span class="text-bold" v-if="item.msg_type_id==3">
                            <span v-html="item.title"></span>
                        </span>
                        <span  class="text-bold" v-else>{{item.title}}</span>
                    </p>
                    <p class="clearfix">
                        <span class="fr">{{item.creator}} {{item.created_at}}</span>
                    </p>
                </li>
            </ul>
        </div>
        <div class="footer-bar tar">
            <span class="action-btn" v-matomo="{behaviorCategory: '消息中心', event: '点击',  name: '即时消息(关闭提示)' }" @click="close">关闭提示</span>
            <span class="action-btn" v-matomo="{behaviorCategory: '消息中心', event: '点击',  name: '即时消息(消息中心)' }" @click="center">消息中心</span>
        </div>
    </el-card>
</template>

<script>
    import {mapMutations} from "vuex";

    export default {
        name: "ImNotify",
        props:{
            list:{
                type:Array,
                default(){
                    return [];
                }
            },
        },
        data(){
            return{
                // list:[
                //     {
                //         "msg_id": "33",
                //         "title": "测试消息标题666666",
                //         "message": "测试消息内容6666",
                //         "record_id": "14",
                //         "created_at": "2023-10-12 16:17:58",
                //         "is_read": "0",
                //         "msg_type_id": "3"
                //     },
                //     {
                //         "msg_id": "30",
                //         "title": "测试消息标题666666",
                //         "message": "测试消息内容6666",
                //         "record_id": "13",
                //         "created_at": "2023-10-12 16:17:58",
                //         "is_read": "0",
                //         "msg_type_id": "3"
                //     },
                // ],
            }
        },
        methods:{
            ...mapMutations('workOrder', [
                'SET_SHOW_QUEUE_MODAL',
            ]),
            center(){
                this.$emit('center');
            },
            close(){
                this.$emit('close');
            },
            openMessage(msg){
                let msgType = msg.msg_type_id||'';
                if(msgType=='3'){
                    /* 通知类 */
                    let $html = new DOMParser().parseFromString(msg.message, 'text/html');
                    let $msgDesc = $html.querySelector('.msg-desc');
                    if(!$msgDesc) return this.$message.error('当前消息没有可以跳转的内容');
                    let taskId = $msgDesc.getAttribute("data-id");
                    let taskType = $msgDesc.getAttribute("data-type");

                    /*type：pop_notification 通知，但是要弹窗展示内容 */

                    if(taskType=='daily_task_detail'){
                        let $router = this.$router.resolve({
                            name:'daily_task',
                            params:{
                                pageType:taskType,
                                search:taskId,
                            },
                            query: {
                                pageType:taskType,
                                search:taskId,
                                date: new Date().getTime(),
                            },
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');

                    }else if(taskType=='mi_batch_task_list'){
                        let $router = this.$router.resolve({
                            name:'mi_batch_create',
                            params:{
                                pageType:taskType,
                                search:taskId,
                            },
                            query: {
                                pageType:taskType,
                                search:taskId,
                                date: new Date().getTime(),
                            },
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType=='mi_batch_v2_task_list'){
                        let $router = this.$router.resolve({
                            name:'mi_batch_v2_create',
                            params:{
                                pageType:taskType,
                                search:taskId,
                            },
                            query: {
                                pageType:taskType,
                                search:taskId,
                                date: new Date().getTime(),
                            },
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType=='pop_notification'){
                        /*type:pop_notification 通知，但是要弹窗展示内容 */
                    }else if(taskType == 'TaskInfoPage') {
                        // 跳工单管理 > 任务管理 > 工单详情
                        let tabsId = $msgDesc.getAttribute("data-tabs");
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'TaskInfoPage',
                                id:taskId,
                                tagsActive: tabsId,
                                show_type: false,
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        window.open($router.href, '_blank');
                    }else if(taskType == 'AssignInfoPage') {
                        // 跳工单管理 > 指派 > 工单详情
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'AssignInfoPage',
                                id:taskId,
                                tagsActive: 1,
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        window.open($router.href, '_blank');
                    }else if(taskType == 'createPage') {
                        // 跳工单管理 > 修改工单
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'createPage',
                                id:taskId,
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        window.open($router.href, '_blank');
                    }else if(taskType == 'MaterialInfoPage') {
                        // 跳工单管理 > 工单详情
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'MaterialInfoPage',
                                id:taskId,
                                tagsActive: 2
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        window.open($router.href, '_blank');
                    }else if(taskType == 'ScheduleManage') {
                        // 跳工单管理 > 排单管理（子tab由 data-tabs 决定：1待排期超期→待排单 / 2撤回→已排单·默认已排单）
                        let tabsId = $msgDesc.getAttribute("data-tabs");
                        let subTab = tabsId == '1' ? 'pool' : 'pending';
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'ScheduleManagePage',
                                subTab: subTab,
                                id:taskId,
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        window.open($router.href, '_blank');
                    }else if(taskType == 'Approval') {
                        // 跳工单管理 > 排单管理 > 审批 tab
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'ScheduleManagePage',
                                subTab:'approval',
                                id:taskId,
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        window.open($router.href, '_blank');
                    }else if(taskType == 'workProcessingCenter') {
                        // 工单任务处理中心
                        this.drawer = false;
                        this.$nextTick(()=>{
                            this.SET_SHOW_QUEUE_MODAL(taskId)
                        })
                    }else if(taskType === 'AdBatchAdjustmentPage') {
                        // 广告批量调控
                        console.log('-', taskType)
                        let $router = this.$router.resolve({
                            name:'ad_batch_adjustment',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        window.open($router.href, '_blank');
                    }else if(taskType === 'vivo_batch_task_list') {
                        // vivo批量任务列表
                        console.log('-', taskType)
                        let $router = this.$router.resolve({
                            name:'vivo_batch_create',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType=='oppo_plan_copy'){
                        let $router = this.$router.resolve({
                            name:'oppo_plan_copy',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType=='huawei_ads'){
                        let $router = this.$router.resolve({
                            name:'huawei_ads',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType=='honor'){
                        let $router = this.$router.resolve({
                            name:'honor',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else{
                        this.drawer = false;
                        this.$message.error('当前消息没有可以跳转的内容');
                    }
                }
                this.$emit('open',msg);
            },

        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-card__body{
        padding: 0;
    }
    .im-notify{
        width: 360px;
        position: fixed;
        right: 10px;
        bottom: 10px;
        z-index: 999;
        border: solid 1px #ccc;

        .title-group{
            line-height: 36px;
            padding: 0 20px;

        }


        .message-list{
            max-height: 300px;
            overflow-y: auto;


            .list-item{
                border-top: solid 1px #f2f2f2;
                padding: 10px 20px 0;

                &:hover{
                    background-color: #efefef;
                }
            }
        }


        .footer-bar{
            background-color: #f2f2f2;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
            border-top: 1px #fff solid;

            .action-btn{
                display: inline-block;
                padding: 0 20px;
                cursor: pointer;
                &:hover{
                    color: #409EFF;
                }
            }

        }

    }
</style>
